module.exports = __webpack_public_path__ + "img/20190513-west2-2.e314bafc.png";